import type { ColumnsType } from "antd/es/table";
import type { TFunction } from "i18next";

import { localizedSortFieldForApi } from "~/shared/lib/localizedSortField";

export const getUsersColumns = (
  t: TFunction,
  options: string[],
  sortField?: string,
  sortType?: string,
  sortableColumns?: string[],
  lang?: string | null,
): ColumnsType<any> =>
  options.map((option): any => {
    const translationKey = `users.${option}`;
    const translatedTitle = t(translationKey);
    const title = translatedTitle !== translationKey ? translatedTitle : option;

    const isSortable = sortableColumns
      ? sortableColumns.includes(option)
      : true;

    const apiKey = localizedSortFieldForApi(option, lang);

    const sortOrder =
      isSortable && sortField === apiKey
        ? sortType === "ASC"
          ? "ascend"
          : sortType === "DESC"
            ? "descend"
            : undefined
        : undefined;

    const base = {
      title,
      dataIndex: option,
      key: apiKey,
      sorter: isSortable,
      sortOrder: isSortable ? sortOrder : undefined,
    };

    if (option === "roleUsers") {
      return {
        ...base,
        render: (_: unknown, record: { role?: { name: string } }) =>
          record.role?.name ?? "",
      };
    }

    if (option === "dealersCount") {
      return {
        ...base,
        render: (_: unknown, record: { role?: { dealerChoice: string }, dealersCount: number }) =>
          record.role?.dealerChoice === "all" ? "Все" : record.dealersCount ?? "-",
      };
    }

    if (option === "status") {
      return {
        ...base,
        render: (_: unknown, record: { status?: string }) => {
          const raw = record.status;
          if (raw == null || raw === "") {
            return "";
          }
          const key = `users.${raw}`;
          const translated = t(key);
          return translated === key ? raw : translated;
        },
      };
    }

    return base;
  });
